import { IEditorV3 } from "@azu-business/editor-v3";
import { ARS, ArsListingBody, LoadFunctionWithData } from "aic";
import axios from "axios";
import { processAxiosError } from "../processAxiosError";
import { ArsCalculationResultDto } from "./getArsTableCalculation";

export interface ArsListingCalculationDto {
  arsListingBody: ArsListingBody<IEditorV3>;
  analysisSet?: ARS.AnalysisSet;
  dataSubset?: ARS.DataSubset;
}

/**
 * Fetches ARS listing calculation results based on the provided ARS listing body parameters.
 *
 * @param backEndUrl - Base backend URL
 * @param params - ARS listing body including IDs, columns, rows and row headers
 * @param controller - AbortController to cancel the request if needed
 * @returns A promise that resolves to the ARS listing calculation results or an error
 */
export const getArsListingCalculation: LoadFunctionWithData<
  ArsListingCalculationDto,
  ArsCalculationResultDto
> = async (backEndUrl: string, params: ArsListingCalculationDto, controller: AbortController) => {
  try {
    const url = `${backEndUrl}Ars/ArsListingCalculation`;

    const response = await axios.post(url, params, {
      signal: controller.signal,
    });

    return {
      success: true,
      data: {
        rows: response.data.rows,
        variables: new Set(response.data.variables),
      },
    };
  } catch (error) {
    return processAxiosError(
      "Get ARS listing calculation failed - please refresh the page and try again",
      error,
    );
  }
};
